<footer class="footer bg-dark fixed-bottom">
    <div class="text-black text-right mr-3">
        <small>&copy; CERO Technologies, 2020</small>
    </div>
</footer>